<div class="show-organization-container" style="min-width: 380px; margin-right: auto; box-shadow: none; border-radius: 0; background: none;">
  <div class="card shadow-sm rounded-4 border-0">
    <div class="card-body p-4">
      <!-- Success message -->
      <div *ngIf="showSuccess" class="alert alert-success col-md-7" role="alert" data-testid="success-alert">
        <button type="button" class="btn-close float-end" aria-label="Close" (click)="dismissSuccessAlert()"></button>
        Organization updated successfully!
      </div>

      <!-- Error message -->
      <div *ngIf="serverError" class="alert alert-danger col-md-7" role="alert" data-testid="error-alert">
        <button type="button" class="btn-close float-end" aria-label="Close" (click)="dismissAlert()"></button>
        {{ serverError?.message || 'A server error occurred. Please try again later.' }}
      </div>

      <!-- Loading indicator -->
      <div *ngIf="isLoading" class="loading-container">
        <div class="d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <p class="text-center mt-2">Loading organization data...</p>
      </div>

      <!-- Organization details -->
      <div *ngIf="!isLoading && organizationData" style="max-width: 940px;" class="organization-details" data-testid="show-organization-details">
        <!-- Header with title and edit button -->
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h3 class="mb-0">Organization Details</h3>
          <div>
            <button type="button" class="btn btn-outline-secondary me-2" (click)="onBack()">
              <i class="fas fa-arrow-left me-1"></i> Back
            </button>
            <button type="button" class="btn btn-primary" (click)="onEdit()" data-testid="edit-organization-btn">
              <i class="fas fa-edit me-1"></i> Edit
            </button>
          </div>
        </div>

        <!-- Basic Information -->
        <div class="row mb-4">
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label fw-bold">Organization Name</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">{{ organizationData.name || 'N/A' }}</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label fw-bold">Display Name</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">{{ organizationData.displayName || 'N/A' }}</p>
            </div>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label fw-bold">Organization Type</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">{{ organizationTypeName || 'N/A' }}</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label fw-bold">Status</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">
                <span [class]="organizationData.active ? 'badge bg-success' : 'badge bg-danger'">
                  {{ organizationData.active ? 'Active' : 'Inactive' }}
                </span>
              </p>
            </div>
          </div>
        </div>

        <!-- Business Information -->
        <div class="row mb-4">
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label fw-bold">Sold To</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">{{ organizationData.soldTo || 'N/A' }}</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label fw-bold">Ship To</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">{{ organizationData.shipTo || 'N/A' }}</p>
            </div>
          </div>
        </div>

        <!-- Address Information -->
        <h5 class="mb-3">Address Information</h5>
        <div class="row mb-4">
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label fw-bold">Address Line 1</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">{{ organizationData.address?.address1 || 'N/A' }}</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label fw-bold">Address Line 2</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">{{ organizationData.address?.address2 || 'N/A' }}</p>
            </div>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label fw-bold">City</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">{{ organizationData.address?.city || 'N/A' }}</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label fw-bold">State</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">{{ organizationData.address?.state || 'N/A' }}</p>
            </div>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label fw-bold">Country</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">{{ organizationData.address?.country || 'N/A' }}</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label fw-bold">Postal Code</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">{{ organizationData.address?.postalCode || 'N/A' }}</p>
            </div>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label fw-bold">Phone</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">{{ organizationData.address?.phone || 'N/A' }}</p>
            </div>
          </div>
        </div>

        <!-- Contact Information -->
        <h5 class="mb-3">Contact Information</h5>
        <div class="row mb-4">
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label fw-bold">First Name</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">{{ organizationData.contactInfo?.firstName || 'N/A' }}</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label fw-bold">Last Name</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">{{ organizationData.contactInfo?.lastName || 'N/A' }}</p>
            </div>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <div class="mb-3">
              <label class="form-label fw-bold">Point of Contact Details</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">{{ organizationData.contactInfo?.pointOfContactDetails || 'N/A' }}</p>
            </div>
          </div>
        </div>

        <!-- Additional Information -->
        <div class="row mb-4">
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label fw-bold">Exclude Referrals</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">
                <span [class]="organizationData.excludeReferrals ? 'badge bg-warning' : 'badge bg-success'">
                  {{ organizationData.excludeReferrals ? 'Yes' : 'No' }}
                </span>
              </p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label fw-bold">Logo</label>
              <p class="form-control-plaintext border rounded p-2 bg-light">{{ organizationData.logoObjectKey || 'No logo uploaded' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
